<template>
  <v-card>
    <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
      Подтверждение записи
    </v-card-title>

    <v-card-text>
      <span v-if="customer">Пациент: {{ customer.last_name }} {{ customer.first_name }} {{ customer.middle_name }}</span>
      <span v-else>Пациент не найден</span>
      <br />
      Доктор: {{ doctor.fullName }}
      <br />
      Дата: {{ $date.unix(time.ts).format("DD.MM.YYYY") }} в {{ time.time }}
    </v-card-text>

    <v-card-text>
      <form id="schedule-appointment-form" @submit.prevent.stop="onSubmit">
        <v-radio-group v-model="form.providingWay" class="mt-0" requ>
          <v-radio v-for="item in providingWays" :key="`${item.id}-providingWay`" required :label="item.name" :value="item.id" />
        </v-radio-group>
      </form>
      <v-btn
        v-if="showDoctors"
        type="button"
        form="schedule-appointment-form"
        small
        @click.native="
          showDoctors = false;
          selectedDoctors = [doctor.id];
        "
        >Скрыть врачей</v-btn
      >
      <v-btn v-else type="button" form="schedule-appointment-form" small @click.native="showDoctors = true"
        >Добавить врача к консилиуму</v-btn
      >

      <div v-if="showDoctors" class="mt-4">
        <v-checkbox
          v-for="doc in otherDoctors"
          :key="doc.user_id"
          v-model="selectedDoctors"
          :label="getDocLabel(doc)"
          :value="doc.id"
          class="mt-0"
        ></v-checkbox>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn type="submit" form="schedule-appointment-form" color="primary">Записаться</v-btn>
      <v-spacer></v-spacer>
      <v-btn type="button" @click="$emit('submit')">Отменить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Doctor } from "@/modules/doctors/Doctor.js";
import { ReferencesRepository } from "@/modules/references/references.repository.js";
import { mapState, mapMutations } from "vuex";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";

export default {
  name: "ScheduleAppointment",

  props: {
    doctor: {
      type: Doctor,
      required: true,
    },

    time: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /** @type {Reference.ServiceProvidingWay[]} */
      providingWays: [],
      form: {
        providingWay: null,
      },
      showDoctors: false,
      selectedDoctors: [],
    };
  },
  computed: {
    ...mapState("appointment", ["doctors"]),
    customer() {
      return this.$store.state.customer.profile;
    },
    otherDoctors() {
      return this.doctors.filter(el => {
        return el.id !== this.doctor.id;
      });
    },
  },
  async created() {
    if (!this.doctors) {
      const doctors = await DoctorsRepository.getAll({
        clinic_id: null,
        specialization_id: null,
        date: null,
        min_date: null,
        name: null,
      });
      this.SET_DOCTORS(doctors);
    }

    this.providingWays = await ReferencesRepository.serviceProvidingWays({ forAppointment: true });
  },

  methods: {
    ...mapMutations("appointment", ["SET_DOCTORS"]),
    onSubmit() {
      this.$emit("submit", { providingWay: this.form.providingWay, additionalDoctors: this.selectedDoctors });
    },
    getDocLabel(doc) {
      const docSpec = doc.specializations.reduce(
        (accumulator, currentValue) => accumulator + ", " + currentValue.localization.specialization_doctor_name,
        "",
      );
      return `${doc.lastName} ${doc.firstName} ${doc.middleName} ${docSpec}`;
    },
  },
};
</script>

<style scoped></style>
